import React, { useCallback, useMemo, useState } from 'react'
import { User, UserRole } from '@/types'
import { ActorUsersPage } from '@/components/users/ActorUsersPage'
import { ActorApkModal } from '@/components/apk/ActorApkModal'
import { createApkColumn } from '@/components/apk/createApkColumn'
import { useAttachedResellersStore } from '@/stores/attached-resellers.store'
import { useAuth } from '@/hooks/useAuth'
import { canManageAttachedResellers, isAdminUser } from '@/utils/role-access'

export const AttachedResellersPage: React.FC = () => {
  const resellers = useAttachedResellersStore(state => state.resellers)
  const fetchAttachedResellers = useAttachedResellersStore(state => state.fetchAttachedResellers)
  const addAttachedReseller = useAttachedResellersStore(state => state.addAttachedReseller)
  const updateAttachedReseller = useAttachedResellersStore(state => state.updateAttachedReseller)
  const deleteAttachedReseller = useAttachedResellersStore(state => state.deleteAttachedReseller)
  const { user } = useAuth()
  const canManage = canManageAttachedResellers(user)
  const [apkActor, setApkActor] = useState<User | null>(null)

  const handleApkClick = useCallback((actor: User) => {
    setApkActor(actor)
  }, [])

  const apkColumn = useMemo(() => createApkColumn(handleApkClick), [handleApkClick])

  return (
    <>
    <ActorUsersPage
      title="Liste des revendeurs rattachés"
      createButtonLabel="Nouveau revendeur rattaché"
      gridCollection="attached-resellers"
      users={resellers}
      fetchUsers={fetchAttachedResellers}
      onCreate={data => addAttachedReseller({ ...data, role: UserRole.RESELLER })}
      onUpdate={updateAttachedReseller}
      onDelete={deleteAttachedReseller}
      canManage={canManage}
      fixedRole={UserRole.RESELLER}
      hideRoleColumn
      showWholesalerColumn={isAdminUser(user)}
      showLoginAs={true}
      createTitle="Nouveau revendeur rattaché"
      editTitle="Modifier le revendeur rattaché"
      autoGeneratePassword
      extraColumns={[apkColumn]}
    />

    {apkActor && (
      <ActorApkModal actor={apkActor} canManage={false} onClose={() => setApkActor(null)} />
    )}
    </>
  )
}
